export default __webpack_public_path__ + "static/media/bell.dbbf178c.svg";